<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="Name" :field="'name'" />
            </v-col>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="Steward Code" :field="'steward_code'" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { type ISteward } from '@app/land-hold/steward/models/Steward.ts';
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { useStewardRepository } from '@app/land-hold/steward/repositories/useStewardRepository';

const props = defineProps({
    item: {
        type: Object as PropType<ISteward>,
        required: true,
    },
});

const update = useStewardRepository().command.update(props.item.id, props.item);
const form = update.form;
useInjectSubmitForm(update.execute);
</script>
